module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp2_8011.ffccc0fb.png";